import React, { useState } from 'react';
import axios from 'axios';
import config from '../config';
import './WaitList.scss';

function WaitList({
  title = "Join Our Wait List",
  subtitle = "Be the first to know when we launch new features!",
  buttonText = "Join Wait List",
  successMessage = "Thank you for joining our wait list!",
  placeholderText = "Enter your email"
}) {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [submitError, setSubmitError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');
    setSubmitError('');

    try {
      await axios.post(`${config.apiUrl}/wait-list`, { email });
      setSubmitMessage(successMessage);
      setEmail('');
    } catch (error) {
      console.error('Error submitting to wait list:', error);
      setSubmitError(error.response?.data?.error || 'An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="wait-list">
      <h2>{title}</h2>
      <p>{subtitle}</p>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={placeholderText}
          required
        />
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : buttonText}
        </button>
      </form>
      {submitMessage && <p className="success-message">{submitMessage}</p>}
      {submitError && <p className="error-message">{submitError}</p>}
    </div>
  );
}

export default WaitList;
